export var checkIfAllValid = refs => refs.every(ref => {
  var _ref$current;

  return (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.value;
});
export var checkIsNumeric = str => {
  if (typeof str !== 'string') return false; // we only process strings!

  return !isNaN(+str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
  !isNaN(parseFloat(str));
};
//# sourceMappingURL=verification-code-field.utils.js.map